import React, { useEffect } from "react";
import { Navigate, Route, useLocation } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "Common/Hooks/UserHooks";

import { logoutUser } from "slices/thunk";
import { canAccessRoute, RouteAccessRule } from "./routeAccess";

type AuthProtectedProps = {
  access?: RouteAccessRule;
  children: React.ReactNode;
};

const AuthProtected = ({ access, children }: AuthProtectedProps) => {
  const dispatch = useDispatch<any>();
  const { userProfile, loading, token } = useProfile();
  const location = useLocation();

  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!userProfile && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  /*
    Navigate is un-auth access protected routes via url
    */

  if (!userProfile || !token) {
    const pendingPath = `${location.pathname}${location.search}${location.hash}`;
    if (!pendingPath.includes("/login")) {
      localStorage.setItem("pending_path", pendingPath);
    }
    return (
      <Navigate to="/login" replace />
    );
  }

  if (!canAccessRoute(access)) {
    return (
      <Navigate
        to="/access-denied"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return <>{children}</>;
};


const AccessRoute = ({ component: Component, ...rest }: any) => {
  return (
    <Route
      {...rest}
      render={(props: any) => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
